import { render, staticRenderFns } from "./BadgeSelect.vue?vue&type=template&id=53b3d463&scoped=true&"
import script from "./BadgeSelect.vue?vue&type=script&lang=js&"
export * from "./BadgeSelect.vue?vue&type=script&lang=js&"
import style0 from "./BadgeSelect.vue?vue&type=style&index=0&id=53b3d463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b3d463",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VSheet,VToolbarTitle})
